import * as React from 'react';

function SvgReleaseNotes(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      width={12}
      height={12}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.144 2.17l1.068-1.066a.486.486 0 01.645.04.49.49 0 01.039.646L9.832 2.857a.486.486 0 01-.689 0 .49.49 0 010-.69v.004zM7.67.045a.905.905 0 00-.485-.02.58.58 0 00-.354.22l-.78 1.19c-.128.195-.006.422.28.521.236.08.525.051.714-.073.056-.037.1-.08.131-.128L7.95.564c.127-.195.005-.422-.28-.52zm3.765 4.001l-1.205.78c-.197.145-.283.498-.196.801.087.304.317.45.522.334l1.205-.787a.454.454 0 00.128-.13.87.87 0 00.039-.774c-.11-.24-.314-.333-.493-.224zm-.603 3.468a.572.572 0 11-.81.81l-.336-.336L4.253 10.4l-1.545.686a.568.568 0 01-.05.747.574.574 0 01-.81 0L.16 10.146a.57.57 0 01.746-.858L4.01 2.312l-.336-.336a.572.572 0 01.809-.808l6.35 6.345z"
        fill="#999"
      />
    </svg>
  );
}

export default SvgReleaseNotes;
